import { render, staticRenderFns } from "./batch-process-attention-vehicle-modal.vue?vue&type=template&id=387ecded"
import script from "./batch-process-attention-vehicle-modal.vue?vue&type=script&lang=js"
export * from "./batch-process-attention-vehicle-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports